(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "react-cookie"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("react-cookie"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.React, global.reactCookie);
    global.CookiesFacet = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _propTypes, _react, _reactCookie) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = cookiesFacetFactory;
  _exports.facet = facet;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  var _excluded = ["isKeepingSession", "domain", "maxAge"];
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
  function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
  function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
  function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
  function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
  function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
  function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  // For more configuration options:
  // https://github.com/reactivestack/cookies/tree/master/packages/react-cookie
  var PATH = '/';
  function facet(WrappedComponent) {
    var _Facet;
    return _Facet = /*#__PURE__*/function (_PureComponent) {
      function Facet() {
        _classCallCheck(this, Facet);
        return _callSuper(this, Facet, arguments);
      }
      _inherits(Facet, _PureComponent);
      return _createClass(Facet, [{
        key: "getCookie",
        value: function getCookie(name, domain) {
          var cookies = this.props.cookies;
          var baseCookiesOption = {
            path: PATH,
            domain: domain
          };
          return cookies.get(name, baseCookiesOption);
        }
      }, {
        key: "getCookieAsObject",
        value: function getCookieAsObject(name, domain) {
          var cookie = this.getCookie(name, domain);
          // JSON.parse will throw a syntax error if the string is not valid JSON object
          try {
            return JSON.parse(cookie);
          } catch (_unused) {
            return undefined;
          }
        }
      }, {
        key: "setCookie",
        value: function setCookie(name, value) {
          var configs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isKeepingSession = configs.isKeepingSession,
            domain = configs.domain,
            maxAge = configs.maxAge,
            otherConfigs = _objectWithoutProperties(configs, _excluded);
          var cookies = this.props.cookies;
          var baseCookiesOption = {
            domain: domain,
            path: PATH,
            maxAge: maxAge
          };
          cookies.set(name, value, _objectSpread(_objectSpread({}, baseCookiesOption), otherConfigs));
        }
      }, {
        key: "removeCookie",
        value: function removeCookie(name, domain) {
          var cookies = this.props.cookies;
          var baseCookiesOption = {
            path: PATH,
            domain: domain
          };
          cookies.remove(name, baseCookiesOption);
        }
      }, {
        key: "render",
        value: function render() {
          var _this = this;
          var rest = _extends({}, (_objectDestructuringEmpty(this.props), this.props));
          return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({
            getAcceptCookie: function getAcceptCookie(domain) {
              return _this.getCookie('accept', domain);
            },
            getAuthCookie: function getAuthCookie(domain) {
              return _this.getCookie('auth', domain);
            },
            getReloadBookingCookie: function getReloadBookingCookie(domain) {
              return _this.getCookieAsObject('reloadBookings', domain);
            }
            // If token param is not passed in, it will be null by default.
            ,
            setAcceptCookie: function setAcceptCookie(configs) {
              return _this.setCookie('accept', '%23alert1', configs);
            },
            setAuthCookie: function setAuthCookie(token, configs) {
              return _this.setCookie('auth', token, configs);
            },
            setReloadBookingCookie: function setReloadBookingCookie(value, configs) {
              return _this.setCookie('reloadBookings', value, configs);
            },
            removeReloadBookingCookie: function removeReloadBookingCookie(domain) {
              return _this.removeCookie('reloadBookings', domain);
            },
            removeAuthCookie: function removeAuthCookie(domain) {
              return _this.removeCookie('auth', domain);
            }
            // eslint-disable-next-line react/jsx-props-no-spreading
          }, rest));
        }
      }]);
    }(_react.PureComponent), _defineProperty(_Facet, "propTypes", {
      cookies: _propTypes["default"].instanceOf(_reactCookie.Cookies).isRequired
    }), _Facet;
  }

  // Higher Order Component that adds Cookies functionality for the wrapped component
  function cookiesFacetFactory(WrappedComponent) {
    var withFacet = facet(WrappedComponent);
    return (0, _reactCookie.withCookies)(withFacet);
  }
});